// Auto-generated by processing/generate_type_chart.py from drool/types.csv — do not edit.
import { Type } from './sim/Enums';

export type EffectivenessValue = 0 | 0.5 | 1 | 2;

// Real types only (excludes the Type.None single-type sentinel).
type RealType = Exclude<Type, Type.None>;

export const TYPE_EFFECTIVENESS_CHART: { [A in RealType]: { [D in RealType]: EffectivenessValue } } = {
  [Type.Yin]: {
    [Type.Yin]: 0,
    [Type.Yang]: 2,
    [Type.Earth]: 1,
    [Type.Liquid]: 1,
    [Type.Fire]: 1,
    [Type.Metal]: 1,
    [Type.Ice]: 1,
    [Type.Nature]: 1,
    [Type.Lightning]: 1,
    [Type.Faith]: 1,
    [Type.Air]: 1,
    [Type.Math]: 2,
    [Type.Cyber]: 1,
    [Type.Cosmic]: 0.5
  },
  [Type.Yang]: {
    [Type.Yin]: 2,
    [Type.Yang]: 0,
    [Type.Earth]: 1,
    [Type.Liquid]: 1,
    [Type.Fire]: 1,
    [Type.Metal]: 1,
    [Type.Ice]: 1,
    [Type.Nature]: 1,
    [Type.Lightning]: 1,
    [Type.Faith]: 1,
    [Type.Air]: 1,
    [Type.Math]: 0.5,
    [Type.Cyber]: 1,
    [Type.Cosmic]: 2
  },
  [Type.Earth]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 1,
    [Type.Liquid]: 0.5,
    [Type.Fire]: 2,
    [Type.Metal]: 1,
    [Type.Ice]: 1,
    [Type.Nature]: 1,
    [Type.Lightning]: 2,
    [Type.Faith]: 0.5,
    [Type.Air]: 0,
    [Type.Math]: 1,
    [Type.Cyber]: 1,
    [Type.Cosmic]: 1
  },
  [Type.Liquid]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 2,
    [Type.Liquid]: 1,
    [Type.Fire]: 2,
    [Type.Metal]: 0.5,
    [Type.Ice]: 1,
    [Type.Nature]: 0.5,
    [Type.Lightning]: 1,
    [Type.Faith]: 1,
    [Type.Air]: 1,
    [Type.Math]: 1,
    [Type.Cyber]: 1,
    [Type.Cosmic]: 1
  },
  [Type.Fire]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 0.5,
    [Type.Liquid]: 0.5,
    [Type.Fire]: 0.5,
    [Type.Metal]: 2,
    [Type.Ice]: 2,
    [Type.Nature]: 2,
    [Type.Lightning]: 1,
    [Type.Faith]: 1,
    [Type.Air]: 1,
    [Type.Math]: 1,
    [Type.Cyber]: 1,
    [Type.Cosmic]: 1
  },
  [Type.Metal]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 1,
    [Type.Liquid]: 1,
    [Type.Fire]: 0.5,
    [Type.Metal]: 1,
    [Type.Ice]: 2,
    [Type.Nature]: 1,
    [Type.Lightning]: 1,
    [Type.Faith]: 1,
    [Type.Air]: 1,
    [Type.Math]: 1,
    [Type.Cyber]: 0.5,
    [Type.Cosmic]: 1
  },
  [Type.Ice]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 1,
    [Type.Liquid]: 0.5,
    [Type.Fire]: 0.5,
    [Type.Metal]: 1,
    [Type.Ice]: 1,
    [Type.Nature]: 2,
    [Type.Lightning]: 1,
    [Type.Faith]: 1,
    [Type.Air]: 2,
    [Type.Math]: 2,
    [Type.Cyber]: 1,
    [Type.Cosmic]: 1
  },
  [Type.Nature]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 2,
    [Type.Liquid]: 2,
    [Type.Fire]: 0.5,
    [Type.Metal]: 0.5,
    [Type.Ice]: 0.5,
    [Type.Nature]: 1,
    [Type.Lightning]: 1,
    [Type.Faith]: 2,
    [Type.Air]: 0.5,
    [Type.Math]: 1,
    [Type.Cyber]: 2,
    [Type.Cosmic]: 2
  },
  [Type.Lightning]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 0,
    [Type.Liquid]: 2,
    [Type.Fire]: 1,
    [Type.Metal]: 2,
    [Type.Ice]: 1,
    [Type.Nature]: 0.5,
    [Type.Lightning]: 1,
    [Type.Faith]: 1,
    [Type.Air]: 2,
    [Type.Math]: 1,
    [Type.Cyber]: 0.5,
    [Type.Cosmic]: 1
  },
  [Type.Faith]: {
    [Type.Yin]: 2,
    [Type.Yang]: 2,
    [Type.Earth]: 1,
    [Type.Liquid]: 1,
    [Type.Fire]: 1,
    [Type.Metal]: 1,
    [Type.Ice]: 1,
    [Type.Nature]: 0.5,
    [Type.Lightning]: 1,
    [Type.Faith]: 1,
    [Type.Air]: 1,
    [Type.Math]: 1,
    [Type.Cyber]: 2,
    [Type.Cosmic]: 0.5
  },
  [Type.Air]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 2,
    [Type.Liquid]: 1,
    [Type.Fire]: 1,
    [Type.Metal]: 0.5,
    [Type.Ice]: 1,
    [Type.Nature]: 2,
    [Type.Lightning]: 0.5,
    [Type.Faith]: 1,
    [Type.Air]: 1,
    [Type.Math]: 1,
    [Type.Cyber]: 1,
    [Type.Cosmic]: 1
  },
  [Type.Math]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 2,
    [Type.Liquid]: 1,
    [Type.Fire]: 1,
    [Type.Metal]: 0.5,
    [Type.Ice]: 1,
    [Type.Nature]: 1,
    [Type.Lightning]: 2,
    [Type.Faith]: 1,
    [Type.Air]: 1,
    [Type.Math]: 1,
    [Type.Cyber]: 1,
    [Type.Cosmic]: 0
  },
  [Type.Cyber]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 1,
    [Type.Liquid]: 1,
    [Type.Fire]: 1,
    [Type.Metal]: 2,
    [Type.Ice]: 1,
    [Type.Nature]: 1,
    [Type.Lightning]: 1,
    [Type.Faith]: 2,
    [Type.Air]: 1,
    [Type.Math]: 0.5,
    [Type.Cyber]: 1,
    [Type.Cosmic]: 1
  },
  [Type.Cosmic]: {
    [Type.Yin]: 1,
    [Type.Yang]: 1,
    [Type.Earth]: 1,
    [Type.Liquid]: 1,
    [Type.Fire]: 1,
    [Type.Metal]: 0.5,
    [Type.Ice]: 1,
    [Type.Nature]: 1,
    [Type.Lightning]: 1,
    [Type.Faith]: 1,
    [Type.Air]: 1,
    [Type.Math]: 2,
    [Type.Cyber]: 2,
    [Type.Cosmic]: 1
  }
} as const;
